import { Component, OnInit } from '@angular/core';
import { DeviceService } from './device.service';

@Component({
	selector: 'portals-try-jotto',
	templateUrl: './try-jotto.component.html',
	styleUrls: ['./try-jotto.component.scss'],
})
export class TryJottoComponent implements OnInit {
	constructor(public deviceService: DeviceService) {} // Change private to public

	words: string[] = ['Residents', 'Customers', 'Consituents', 'Associates', 'Employees', 'Clients'];
	displayText = '';
	private wordIndex = 0;
	private charIndex = 0;
	private isDeleting = false;
	private typingSpeed = 50;
	private pauseBetweenWords = 2000;
	private timer: any;

	ngOnInit() {
		this.type();
	}

	ngOnDestroy() {
		clearTimeout(this.timer);
	}

	type() {
		const currentWord = this.words[this.wordIndex];
		const fullText = this.isDeleting ? currentWord.substring(0, this.charIndex - 1) : currentWord.substring(0, this.charIndex + 1);

		this.displayText = fullText;
		this.charIndex = this.isDeleting ? this.charIndex - 1 : this.charIndex + 1;

		if (!this.isDeleting && this.charIndex === currentWord.length) {
			this.isDeleting = true;
			this.timer = setTimeout(() => this.type(), this.pauseBetweenWords);
		} else if (this.isDeleting && this.charIndex === 0) {
			this.isDeleting = false;
			this.wordIndex = (this.wordIndex + 1) % this.words.length;
			this.timer = setTimeout(() => this.type(), 500);
		} else {
			this.timer = setTimeout(() => this.type(), this.typingSpeed);
		}
	}
}
